import { render, staticRenderFns } from "./BuilderNps.vue?vue&type=template&id=af95e2c8&scoped=true&"
import script from "./BuilderNps.vue?vue&type=script&lang=js&"
export * from "./BuilderNps.vue?vue&type=script&lang=js&"
import style0 from "./BuilderNps.vue?vue&type=style&index=0&id=af95e2c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af95e2c8",
  null
  
)

export default component.exports